import styles from './ActiveSimInfo.module.css'
import React, {useRef, useState} from "react";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import {Simulate} from "react-dom/test-utils";
import abort = Simulate.abort;
export default function ActiveSimInfo()
{
    const [mode,setMode] = useState(0)
    const errorLineRef = useRef<ErrorLineItemRef>(null)
    const simData = useRef({
        ctn:""
    })

    const [validCtn,setValidCtn] = useState(false)

    const [docData, setDocData] = useState({
        serial:"",
        number:""
    })

    const [ctnInfo,setCtnInfo] = useState({
        ctn:"",
        icc:"",
        family:"",
        name: "",
        middleName : "",
        doc: "",
        docType:"",
        docDate:"",
        user:"",
        oper:"",
        birthDate:"",
        actDate:"",
        dummyPass:false,
        count:0,
        city:"",
        street:"",
        home:"",
        room:""


    })

    const [ctn,setCtn] = useState("")
    const [ldrSimData,rsSimData,exSimData] = useApiQuery("/api/application/sim/activate/info","post",simData);

    const removeSimData = useRef({
        serial:"",
        number:""
    })
    const [ldrRemovePass,rsRemovePass,exRemovePass] = useApiQuery("/api/application/sim/pass/remove","post",removeSimData);


    const handleFind = () =>{
        if(!ctn.match(/9[0-9]{9}/ui))
        {
            if(errorLineRef.current !== null)errorLineRef.current?.show("Не корректный номер",true,2000)
            return

        }

        simData.current.ctn = ctn
            //setCtn("")
        exSimData().then((e)=>{
            console.log(e)
            if(e?.success !== undefined && e.success)
            {
                const actData = e?.payload?.actInfo
                const addressData = e?.payload?.addressInfo

                if(errorLineRef.current !== null)errorLineRef.current?.show("Задача выполнена",false,2000)
                setMode(1)
                const passData = actData?.passData?.split(';')
                if(!Array.isArray(passData))
                {
                    setMode(2)
                    return;
                }
                const dummy = passData[10] === undefined ? true : Number(passData[10]) === 0 ? false : true
                console.log("dummy" ,passData[10],dummy)

                let info = {
                    ctn: actData?.ctn,
                    icc: actData?.icc,
                    family: passData[0],
                    name : passData[1],
                    middleName: passData[2],
                    doc: passData[6]+passData[7],
                    docDate: new Date(passData[8]).toLocaleString().substring(0,10),
                    birthDate: new Date(passData[3]).toLocaleString().substring(0,10),
                    docType: passData[5]?.match(/r/ui) ? "РФ" : "Иностранный",
                    user: actData?.user,
                    oper: actData?.oper,
                    actDate: new Date(actData?.actDate).toLocaleString().substring(0,10),
                    count: 0,
                    dummyPass: dummy,
                    city:"",
                    street :"",
                    home:"",
                    room: ""

                }
                console.log("isArray",Array.isArray(addressData))
                if(Array.isArray(addressData) && addressData.length)
                {
                    info = {...info,
                        city: addressData[0]?.useCity ? addressData[0]?.useCity : "",
                        street: addressData[0]?.useStreet ? addressData[0]?.useStreet : "",
                        home: addressData[0]?.useHome ? addressData[0]?.useHome : "",
                        room: addressData[0]?.useRoom ? addressData[0]?.useRoom : "",
                        count: addressData[0]?.useCount ? addressData[0]?.useCount : "",
                    }
                }

                setCtnInfo(info)
                setDocData({
                    serial: passData[6],
                    number: passData[7]
                })






                return
            }
            if(errorLineRef.current !== null)errorLineRef.current?.show(e?.errorAsString ? e.errorAsString : "Ошибка сервера",true,2000)
        })
    }

    const normCtn = (vl:any):string =>{
        const val = typeof vl === "string" ? vl.trim() : vl.toString()
        const kl = val.match(/9[0-9]{9}$/ui)
        if(kl) {
            return kl[0]
        }
        return  val
    }

    const handlePassRemove = ()=>{
        removeSimData.current.serial = docData.serial
        removeSimData.current.number = docData.number


        exRemovePass().then((e)=>{
            if(e?.success)
            {
                if(Number(e?.payload?.count) > 0)
                {
                    if(errorLineRef.current)errorLineRef.current.show("Паспорт удален",false,5000)
                    return
                }
                if(errorLineRef.current)errorLineRef.current.show("Паспотр уже удален",true,5000)
                return;
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ?e?.errorAsString : "Ошибка сервера" ,true,2000)
        }).catch((e)=>{
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ?e?.errorAsString : "Ошибка сервера" ,true,2000)
        })
    }

    const address = `г. ${ctnInfo.city}, ул. ${ctnInfo.street}, д. ${ctnInfo.home}, кв. ${ctnInfo.room}`
    return(
        <div className={[styles.mainCont].join(' ')}>

            <MainFormTemplate title={"Поиск SIM карты"} maxWidth={"1500px"}>
                <div className={"row"}>
                    <div className={"col-sm-6"}>
                        <InputItem
                            val={ctn}
                            type={"numeric"}
                            mode={"ei"}
                            title={"Номер"}
                            info={"10 цифр"}
                            onChange={(e)=>{
                                const vl = e?.toString()
                                setCtn(normCtn(vl))
                                if(vl?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
                                {
                                    setValidCtn(true)
                                    return
                                }
                                setValidCtn(false)
                            }}

                            regExp={/^((\+7)|(8)|(^))9[0-9]{9}$/ui}/>


                    </div>
                    <div className={"col-sm-2 d-flex align-self-center"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    disabled={!validCtn}
                                    onClick={()=>handleFind()}
                            >Поиск</button>
                            <WaitLoader loading={ldrSimData} api={rsSimData} onlyLoading={true} >
                            </WaitLoader>

                        </div>
                    </div>
                    <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>

                    {mode ===1 &&
                    <div>
                        <div className={"row"}>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.dummyPass}
                                    mode={""}
                                    title={"Фиктивный документ"}
                                    inputType={1}

                                />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.ctn}
                                    mode={""}
                                    title={"Номер"}
                                    />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.icc}
                                    mode={""}
                                    title={"ICC"}
                                />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.actDate}
                                    mode={""}
                                    title={"Дата активации"}
                                />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.family}
                                    mode={""}
                                    title={"Фамилия"}
                                />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.name}
                                    mode={""}
                                    title={"Имя"}
                                />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.middleName}
                                    mode={""}
                                    title={"Отчество"}
                                />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.doc}
                                    mode={""}
                                    title={"Документ"}
                                />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.docDate}
                                    mode={""}
                                    title={"Выдан"}
                                />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.docType}
                                    mode={""}
                                    title={"Тип"}
                                />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.birthDate}
                                    mode={""}
                                    title={"Дата рождения"}
                                />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.oper}
                                    mode={""}
                                    title={"Оператор"}
                                />
                            </div>
                            <div className={"col-sm-4"}>
                                <InputItem
                                    val={ctnInfo.user}
                                    mode={""}
                                    title={"Пользователь"}
                                />
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col-sm-3"}>
                                <InputItem
                                    val={ctnInfo.count}
                                    mode={""}
                                    title={"Количество"}
                                />
                            </div>
                            <div className={"col-sm-9"}>
                                <InputItem
                                    val={address}
                                    mode={""}
                                    title={"Адресс"}
                                />
                            </div>

                        </div>

                        <div className={"row justify-content-start py-2"}>
                            <div className={styles.btnCont}>
                                <div className={styles.btnCont}>
                                    <button type="button" className="btn btn-secondary "
                                            onClick={()=>handlePassRemove()}
                                    >{`Удалить паспорт`}</button>

                                </div>
                            </div>
                        </div>



                    </div>
                    }

                </div>


            </MainFormTemplate>
        </div>
    )
}